import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import "./JobSubCategory.css"
import JobSubCategoryService from "../../admin/Shared/Services/JobSubCategoryService";
import JobCategoryService from "../../admin/Shared/Services/JobCategoryService";
import SweetAlertService from "../../../services/SweetAlertService";
import { errorMessages, getMaxLengthErrorMessage, getRequiredErrorMessage, jobSubCategoryNameMaxLength, jobCategoryActivityNamePattern } from "../Shared/Constants/AdminModuleConstants";

export const AddJobSubCategory = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { register, handleSubmit, setValue, reset, formState: { errors } }
        = useForm({ defaultValues: { jobCategoryId: "", name: "" } });

    const [jobCategoryList, setJobCategoryList] = useState([]);

    useEffect(() => {
        getAllJobCategories();
    }, []);

    const getAllJobCategories = () => {
        JobCategoryService.getAllJobCategoryList().then((response) => {
            setJobCategoryList(response.data);
            setTimeout(() => {
                setValue("jobCategoryId", id??"");
            }, 25);
        })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while getting job categorie");
            });
    }

    const onSubmit = (data: any) => {
        data.name = data.name.trim();
        //data.isDefaultInWorkActivity = data.isDefaultInWorkActivity == 'true';
        data.isSystemDefined = true;
        JobSubCategoryService.addJobSubCategory(data).then((response) => {
            if (response.data > 0) {
                reset();
                navigate("/jobsubcategory/" + data.jobCategoryId);
            } else {
                SweetAlertService.error("Error", "Something went wrong while adding job sub-category");
            }
        }).catch(error => {
            SweetAlertService.error("Error", error.response.data.errors.Name[0])
        })
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Create job subcategory</h4>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">Job Category</label>
                        <div className="col-lg-9">
                            <select className="form-select"
                                {...register("jobCategoryId", { required: getRequiredErrorMessage("Job Category"), })}>
                                <option value="">Please select Job category</option>
                                if (jobCategoryList.length)
                                {
                                    jobCategoryList.map((e: any) => (
                                        <option value={e.id} key={e.id}>{e.name}</option>
                                    ))
                                }
                            </select>
                            {errors.jobCategoryId && (
                                <span className="help-block m-b-none text-danger field-validation-valid">{errors.jobCategoryId.message?.toString()}</span>
                            )}
                        </div>
                    </div>
                    <br />
                    <div className="form-group row">
                        <label className="col-lg-3 control-label">Name</label>
                        <div className="col-lg-9">
                            <input
                                type="text"
                                className="form-control"
                                {...register("name", {
                                    required: getRequiredErrorMessage("Name"),
                                    maxLength: {
                                        value: jobSubCategoryNameMaxLength,
                                        message: getMaxLengthErrorMessage(jobSubCategoryNameMaxLength)
                                    },
                                    pattern: {
                                        value: jobCategoryActivityNamePattern,
                                        message: errorMessages.pattern
                                    },
                                })}
                            />
                            {errors.name && (
                                <span className="help-block m-b-none text-danger field-validation-valid">{errors.name.message?.toString()}</span>
                            )}
                        </div>
                    </div>
                    {/*<br />*/}
                    {/*<div className="form-group row">*/}
                    {/*    <label className="col-lg-3 control-label">Is Default In WorkActivity</label>*/}
                    {/*    <div className="col-lg-9">*/}
                    {/*        <div className="d-flex flex-row">*/}
                    {/*            <input*/}
                    {/*                value="true"*/}
                    {/*                type="radio"*/}
                    {/*                {...register("isDefaultInWorkActivity")}*/}
                    {/*            />Yes*/}
                    {/*            <input className="ms-3"*/}
                    {/*                value="false"*/}
                    {/*                type="radio"*/}
                    {/*                {...register("isDefaultInWorkActivity")}*/}
                    {/*            />No*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <br />
                    <div className="form-group row">
                        <div className=" col-sm-offset-3 px-2">
                            <a className="btn btn-secondary"
                                onClick={() => navigate('/jobcategory')}>
                                Cancel
                            </a>
                            <button className="btn btn-primary ms-1"
                                type="submit">
                                Create
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}